import AbstractNode from './AbstractNode';
import {toggleList} from '../plugins/commands';
import {wrappingInputRule} from 'prosemirror-inputrules';

export default class CheckBoxList extends AbstractNode {
    get name() {
        return "checkbox_list";
    }

    get schema() {
        return {
            attrs: {
                tight: {default: true}
            },
            group: "block",
            content: "checkbox_item+",
            parseDOM: [{
                tag: 'ul.task-list'
            }],
            toDOM: () => ["ul", {
                class: 'task-list'
            }, 0]
        }
    }

    toMarkdown(state, node) {
        state.renderList(node, "  ", () => "* ");
    }

    get parseMarkdown() {
        return {
            block: "checkbox_list"
        };
    }

    inputRules({type}) {
        return [wrappingInputRule(/^\s*(\[[ xX]])\s$/, type)];
    }

    keys({type, schema}) {
        return {
            "Shift-Ctrl-7": toggleList(type, schema.nodes.checkbox_item)
        };
    }

    commands({type, schema}) {
        return {
            createTodoList: () => view => toggleList(type, schema.nodes.checkbox_item)(view.state, view.dispatch)
        }
    }
}